export default "__VITE_ASSET__pFMX81du__"